import { CalendarIcon } from '@heroicons/react/24/solid';
import LinkTo from 'components/LinkTo';
import { getModelFromSnapshot } from 'lib/model';
import { OrganizationModel } from 'lib/model/objects/organizationModel';
import { EOrganization, ESnapshotExists } from 'lib/types';
import { selectIsOnSubdomain, selectIsPublisher } from 'redux/auth';
import { useAppSelector } from 'redux/hooks';
import { getNewspaperLogo } from 'routes/ads/place/helpers/newspapers';
import { getFirebaseContext } from 'utils/firebase';

type SubdomainPublisherHeaderProps = {
  publisherOrganization: ESnapshotExists<EOrganization> | undefined;
};
export default function SubdomainPublisherHeader({
  publisherOrganization
}: SubdomainPublisherHeaderProps) {
  const isOnSubdomain = useAppSelector(selectIsOnSubdomain);
  const isUserPublisher = useAppSelector(selectIsPublisher);

  if (!isOnSubdomain || isUserPublisher) {
    return null;
  }

  if (!publisherOrganization) {
    return <div>Please select a publisher organization.</div>;
  }

  const publisherOrganizationModel = getModelFromSnapshot(
    OrganizationModel,
    getFirebaseContext(),
    publisherOrganization
  );

  const publisherLogo = getNewspaperLogo(publisherOrganizationModel);

  return (
    <div className="space-y-2">
      {publisherLogo && (
        <div>
          <img
            className="h-12 max-w-48 object-contain rounded-lg"
            src={publisherLogo}
          />
        </div>
      )}
      <div>
        <h2 className="text-lg text-column-gray-700 font-semibold">
          {publisherOrganization.data().name}
          <span className="text-sm font-normal"> | Public Notices</span>
        </h2>
        <p className="text-sm font-normal">
          {publisherOrganizationModel.modelData.city},{' '}
          {publisherOrganizationModel.stateLabel}
        </p>
      </div>
      <div className="text-sm space-x-3 text-column-primary-700">
        <LinkTo target="_blank" href="/schedule">
          <CalendarIcon className="w-5 h-5 inline-block" /> Check publication
          schedule
        </LinkTo>
      </div>
    </div>
  );
}
